import { FilterI } from '~src/shared/lists/listFilters/ListFilters';
import { TopicSubject } from '~src/interfaces/topic.interface';

export const topicTypeFilterOpts: FilterI[] = [
  {
    id: 'all',
    labelKey: 'x.reports.topic_list.sorting.all',
    itemsAmount: 0,
  },
  {
    id: TopicSubject.People,
    labelKey: 'x.reports.topic_list.sorting.people',
    iconName: 'iconPeople',
    itemsAmount: 0,
  },
  {
    id: TopicSubject.General,
    labelKey: 'x.reports.topic_list.sorting.general',
    iconName: 'iconPulse',
    itemsAmount: 0,
  },
  {
    id: TopicSubject.Groups,
    labelKey: 'x.reports.topic_list.sorting.groups',
    iconName: 'iconGroups',
    itemsAmount: 0,
  },
];

const participantsLabelPrefix = 'x.reports.participants.selector.';

export const participantsRespondentLabels = [
  `${participantsLabelPrefix}completed`,
  `${participantsLabelPrefix}90`,
  `${participantsLabelPrefix}80`,
  `${participantsLabelPrefix}70`,
  `${participantsLabelPrefix}60`,
  `${participantsLabelPrefix}50`,
  `${participantsLabelPrefix}40`,
  `${participantsLabelPrefix}30`,
  `${participantsLabelPrefix}20`,
  `${participantsLabelPrefix}10`,
  `${participantsLabelPrefix}0`,
  `${participantsLabelPrefix}not_started`,
];

export const selectorRespondentLabels = [...participantsRespondentLabels].reverse();

export enum BenchmarkFilterKeys {
  FarAbove = 'far_above',
  Above = 'above',
  Average = 'average',
  Below = 'below',
  FarBelow = 'far_below',
}

export const improveBenchmarkLabels = {
  [BenchmarkFilterKeys.FarAbove]: 'x.reports.improve.selector.far_above_average',
  [BenchmarkFilterKeys.Above]: 'x.reports.improve.selector.above_average',
  [BenchmarkFilterKeys.Average]: 'x.reports.improve.selector.average',
  [BenchmarkFilterKeys.Below]: 'x.reports.improve.selector.below_average',
  [BenchmarkFilterKeys.FarBelow]: 'x.reports.improve.selector.far_below_average',
};
